import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getSidebarBannersApi } from '../../api/axios';

const WHATSAPP_PHONE = '5493492587720';
const ELECTRO_FANS_WHATSAPP_PHONE = '5493492594736';
const BANNER_ROTATION_MS = 3000;

const normalizeImageUrl = (urlImagen) => (
    typeof urlImagen === 'string'
        ? urlImagen.replace('/api/Banners/archivo/', '/api/SidebarBanners/archivo/')
        : ''
);

const DEFAULT_BANNERS = [
    {
        urlImagen: '/banners/electroFans.jpg',
        titulo: 'Electro Fans',
        textoModal: 'Estas interesado en mejorar tu posicionamiento durante el Electro Fans?',
        contactType: 'whatsapp',
        telefonoWhatsapp: ELECTRO_FANS_WHATSAPP_PHONE,
        mensajeWhatsapp: 'Hola, estoy interesado en mejorar mi posicionamiento durante el Electro Fans, ¿me comentas las opciones? ',
        textoBoton: 'Consultar Asesor'
    },
    {
        urlImagen: '/banners/Banner_1.jpg',
        titulo: 'Seguros Megatone.Net',
        contactType: 'whatsapp',
        mensajeWhatsapp: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.',
        textoBoton: 'Consultar Asesor'
    },
    {
        urlImagen: '/banners/Banner_2.jpg',
        titulo: 'Seguros Megatone.Net',
        contactType: 'whatsapp',
        mensajeWhatsapp: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.',
        textoBoton: 'Consultar Asesor'
    },
    {
        urlImagen: '/banners/Banner_3.jpg',
        titulo: 'Seguros Megatone.Net',
        contactType: 'whatsapp',
        mensajeWhatsapp: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.',
        textoBoton: 'Consultar Asesor'
    }
];

const normalizeBanners = (items) => (
    (Array.isArray(items) ? items : [])
        .filter((banner) => banner?.urlImagen && banner.visible !== false)
        .map((banner) => ({
            ...banner,
            urlImagen: normalizeImageUrl(banner.urlImagen),
            contactType: banner.idContacto === 2 ? 'email' : 'whatsapp',
            textoBoton: banner.textoBoton || 'Consultar'
        }))
);

const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

const buildContactLink = (banner) => {
    if (banner?.contactType === 'email' && banner.email) {
        const params = [];
        if (banner.asuntoEmail) {
            params.push(`subject=${encodeURIComponent(banner.asuntoEmail)}`);
        }
        if (banner.cuerpoEmail) {
            params.push(`body=${encodeURIComponent(banner.cuerpoEmail)}`);
        }
        return `mailto:${banner.email}${params.length ? `?${params.join('&')}` : ''}`;
    }

    const phone = digitsOnly(banner?.telefonoWhatsapp) || WHATSAPP_PHONE;
    const message = banner?.mensajeWhatsapp || 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.';
    return `https://web.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;
};

const SidebarBannersWhatsappWeb = () => {
    const [banners, setBanners] = useState(DEFAULT_BANNERS);
    const [currentImage, setCurrentImage] = useState(0);
    const [selectedBanner, setSelectedBanner] = useState(null);

    useEffect(() => {
        const loadBanners = () => {
            getSidebarBannersApi()
                .then((data) => {
                    const loaded = normalizeBanners(data?.banners);
                    if (loaded.length > 0) {
                        setBanners(loaded);
                        setCurrentImage(0);
                    } else {
                        setBanners([]);
                    }
                })
                .catch(() => {
                    setBanners(DEFAULT_BANNERS);
                });
        };

        loadBanners();
        window.addEventListener('sidebar-banners-updated', loadBanners);
        return () => window.removeEventListener('sidebar-banners-updated', loadBanners);
    }, []);

    useEffect(() => {
        if (selectedBanner || banners.length <= 1) {
            return undefined;
        }

        const intervalId = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % banners.length);
        }, BANNER_ROTATION_MS);

        return () => clearInterval(intervalId);
    }, [selectedBanner, banners.length]);

    if (banners.length === 0) {
        return null;
    }

    const handleOpenModal = (banner) => {
        setSelectedBanner(banner);
    };

    const handleCloseModal = () => {
        setSelectedBanner(null);
    };

    const isEmailContact = selectedBanner?.contactType === 'email';

    return (
        <>
            <div className="sidebar-banner-container text-center">
                <style>
                    {`
                        @keyframes fadeInBanner {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }

                        @media (min-width: 768px) {
                            body.mini-sidebar .sidebar-banner-container {
                                display: none !important;
                            }
                        }

                        .sidebar-banner-button {
                            background: transparent;
                            border: 0;
                            padding: 0;
                            width: 100%;
                            cursor: pointer;
                        }

                        .sidebar-banner-button:focus-visible {
                            outline: 2px solid #25d366;
                            outline-offset: 4px;
                            border-radius: 0.5rem;
                        }

                        .sidebar-banner-image {
                            display: block;
                            width: 100%;
                            height: auto;
                            max-height: min(240px, 32vh);
                            object-fit: contain;
                            object-position: center;
                            background: transparent;
                            transition: transform 0.2s ease;
                        }

                        .sidebar-banner-button:hover .sidebar-banner-image {
                            transform: scale(1.02);
                        }

                        .sidebar-banner-modal-dialog {
                            max-width: 680px;
                        }

                        .sidebar-banner-modal-dialog .modal-content {
                            border: 0;
                            border-radius: 24px;
                            overflow: hidden;
                            background: linear-gradient(180deg, #ffffff 0%, #f6f8fb 100%);
                            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
                        }

                        .sidebar-banner-modal-dialog .modal-header {
                            border-bottom: 0;
                            padding: 1.25rem 1.25rem 0.75rem;
                        }

                        .sidebar-banner-modal-dialog .modal-title {
                            color: #18212f;
                            font-size: 1.15rem;
                            font-weight: 700;
                        }

                        .sidebar-banner-modal-dialog .modal-body {
                            padding: 0 1.25rem 1rem;
                        }

                        .sidebar-banner-modal-dialog .modal-footer {
                            border-top: 0;
                            padding: 0 1.25rem 1.25rem;
                            gap: 0.75rem;
                        }

                        .sidebar-banner-preview {
                            background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
                            border: 1px solid rgba(148, 163, 184, 0.2);
                            border-radius: 20px;
                            padding: 1rem;
                        }

                        .sidebar-banner-preview img {
                            display: block;
                            width: auto;
                            max-width: min(100%, 520px);
                            max-height: 56vh;
                            margin: 0 auto;
                            object-fit: contain;
                        }

                        .sidebar-banner-caption {
                            color: #5b6472;
                            font-size: 0.95rem;
                            margin-top: 0.9rem;
                        }

                        .sidebar-banner-whatsapp-btn,
                        .sidebar-banner-email-btn {
                            min-width: 150px;
                            border-radius: 12px;
                            font-weight: 600;
                            padding: 0.7rem 1rem;
                            border: 0;
                        }

                        .sidebar-banner-whatsapp-btn {
                            background: linear-gradient(135deg, #25d366 0%, #19b955 100%);
                            box-shadow: 0 12px 24px rgba(37, 211, 102, 0.22);
                        }

                        .sidebar-banner-whatsapp-btn:hover,
                        .sidebar-banner-whatsapp-btn:focus {
                            background: linear-gradient(135deg, #1fc55e 0%, #17a84d 100%);
                        }

                        .sidebar-banner-email-btn {
                            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                            box-shadow: 0 12px 24px rgba(37, 99, 235, 0.22);
                        }

                        .sidebar-banner-email-btn:hover,
                        .sidebar-banner-email-btn:focus {
                            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                        }
                    `}
                </style>
                {banners.map((banner, index) => (
                    <button
                        key={banner.id || `${banner.urlImagen}-${index}`}
                        type="button"
                        className="sidebar-banner-button"
                        onClick={() => handleOpenModal(banner)}
                        aria-label={`Abrir ${banner.titulo}`}
                        style={{
                            display: index === currentImage ? 'block' : 'none',
                            animation: index === currentImage ? 'fadeInBanner 0.3s ease-in' : 'none'
                        }}
                    >
                        <img
                            src={banner.urlImagen}
                            alt={banner.titulo}
                            className="sidebar-banner-image img-fluid rounded shadow-sm"
                        />
                    </button>
                ))}
            </div>

            <Modal
                show={Boolean(selectedBanner)}
                onHide={handleCloseModal}
                centered
                dialogClassName="sidebar-banner-modal-dialog"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{selectedBanner?.titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedBanner && (
                        <div className="sidebar-banner-preview">
                            <img
                                src={selectedBanner.urlImagen}
                                alt={selectedBanner.titulo}
                                className="img-fluid rounded shadow-sm"
                            />
                            <p className="sidebar-banner-caption mb-0">
                                {selectedBanner.textoModal || 'Si te interesa esta propuesta, podés consultar con el mensaje ya preparado.'}
                            </p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    {selectedBanner && (
                        <Button
                            as="a"
                            href={buildContactLink(selectedBanner)}
                            target={isEmailContact ? undefined : '_blank'}
                            rel={isEmailContact ? undefined : 'noreferrer'}
                            className={isEmailContact ? 'sidebar-banner-email-btn' : 'sidebar-banner-whatsapp-btn'}
                        >
                            {selectedBanner.textoBoton || 'Consultar'}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SidebarBannersWhatsappWeb;
